module.exports = __webpack_public_path__ + "img/group25@2x-ct.5363c759.png";